import { NavigationLink } from '../../../../../elements/public_api';
import { Cell, CellType } from '../_base/table-cell.entity';

export interface LinkCellInterface {
    title: string;
    info?: string;
    navigationLink: NavigationLink;
}

export class LinkCell extends Cell implements LinkCellInterface {
    public title: string;
    public info?: string;
    public navigationLink: NavigationLink;

    constructor({ title, info, navigationLink }: LinkCellInterface) {
        super(CellType.LINK);
        this.title = title;
        this.info = info;
        this.navigationLink = navigationLink;
    }
}
